export const FONT_WEIGHTS = {
  THIN: 100,
  EXTRA_LIGHT: 200,
  LIGHT: 300,
  NORMAL: 400,
  MEDIUM: 500,
  SEMIBOLD: 600,
  BOLD: 700,
  EXTRA_BOLD: 800,
  BLACK: 900,
} as const;

export const isBoldWeight = (weight: number): boolean =>
  weight >= FONT_WEIGHTS.SEMIBOLD;

export const parseFontWeight = (
  weight: string | number | undefined,
): number => {
  if (!weight) return FONT_WEIGHTS.NORMAL;

  const numWeight =
    typeof weight === "number" ? weight : parseInt(String(weight), 10);
  return isNaN(numWeight) ? FONT_WEIGHTS.NORMAL : numWeight;
};

export const calculateBoldWeight = (baseWeight: number): number =>
  isBoldWeight(baseWeight) ? FONT_WEIGHTS.BLACK : FONT_WEIGHTS.BOLD;
